<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head1">Preface</p>
<p class="noindent">At the intersection of Florida Avenue NW, T Street NW and Sixth Street NW in Washington, D.C., there is an iron gate that reads “LeDroit Park 1873.” It is surrounded by eastern redbuds that bloom bright purple. Each spring, residents and tourists arrive with cameras in hand to photograph the #cherryblossoms. They aren’t cherry blossoms, but that is beside the point.</p>
<p class="indent">The historic neighborhood of LeDroit Park beyond the gate is more than its photogenic façades and springtime flora. It has been called the “Gardens of Washington, DC.” Among the tulips and wisteria is one of the earliest suburbs of the nation’s capital that blossomed into a community of elite Black Washington.</p>
<p class="indent">When I first moved to Washington, D.C., in 2011, I lived at the corner of Rhode Island Avenue NW and Second Street NW. It was the wrong corner to be technically in historic LeDroit Park, but it was close enough that I spent time wandering the streets and admiring the homes. For a decade, I slowly collected stories of who built and lived in these homes.</p>
<p class="indent">And every spring, when thousands of people tagged photos of the arch, I wondered, do they know these stories? Did they walk through the arch and into the neighborhood or just post their photos to Instagram and head to brunch across the street? There’s nothing wrong with that; the brunch at neighborhood eateries is delicious. But there is much more to LeDroit Park.</p>
<p class="indent">I follow in the footsteps of Theresa Brown and Lauretta Jackson, who led the effort to save the neighborhood’s history, and Eric Fidler, who documented its history and everyday happenings in his blog, <i>Left for LeDroit</i>.</p>
<p class="indent">I hope this book will guide anyone interested in the neighborhood to cross Sixth Street from the arch and walk through historic LeDroit Park.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Preface.vue?10fb406d